import { Marker, Popup, type Map as MlMap } from "maplibre-gl";
import { fr } from "../i18n/fr";
import type { LatLonPt } from "./RouteMap";

/** Place found by the search box, shown on the map until another search or its closing (C2). */
export interface SearchResult {
  position: LatLonPt;
  label: string;
  detail?: string;
  /** buttons of the popup, for example "Définir comme départ" on the route test page */
  actions?: { label: string; run(): void }[];
}

/**
 * Marker of a search result with its popup: label, detail and actions. One marker at a time per map, replaced
 * by the next search, removed by the × of the popup or when the search box is emptied.
 */
export class SearchMarker {
  private marker: Marker | null = null;

  show(map: MlMap, r: SearchResult | null) {
    this.clear();
    if (!r) return;
    const el = document.createElement("div");
    el.className = "search-pin";
    el.title = fr.legend.searchResult;
    const box = document.createElement("div");
    box.className = "search-popup";
    const title = document.createElement("strong");
    title.textContent = r.label;
    box.appendChild(title);
    if (r.detail) { const d = document.createElement("div"); d.className = "muted small"; d.textContent = r.detail; box.appendChild(d); }
    if (r.actions?.length) {
      const row = document.createElement("div");
      row.className = "row wrap";
      for (const a of r.actions) {
        const b = document.createElement("button");
        b.type = "button"; b.className = "small"; b.textContent = a.label;
        b.addEventListener("click", () => { a.run(); this.clear(); });
        row.appendChild(b);
      }
      box.appendChild(row);
    }
    const popup = new Popup({ offset: 28, closeButton: true, closeOnClick: false, maxWidth: "280px" }).setDOMContent(box);
    popup.on("close", () => { if (this.marker?.getPopup() === popup) this.clear(); });
    this.marker = new Marker({ element: el, anchor: "bottom" }).setLngLat([r.position.lon, r.position.lat]).setPopup(popup).addTo(map);
    this.marker.togglePopup();
  }

  clear() {
    const m = this.marker;
    this.marker = null;
    m?.remove();
  }
}
